module.exports = __webpack_public_path__ + "img/button_cancel.d1b821e4.png";